import { useAppContext } from '@contexts/app/hooks/useAppContext';
import { ULPath } from '@ul/common';

/**
 * this is intentionally not exported
 * because we should use usePath() instead to get path with culture code
 *
 */
const pathRecord: Record<ULPath, string> = {
    signin: '/ul/login/signin',
    otpLogin: '/ul/login/otpLogin',
    socialSignin: '/ul/login/socialSignin',
    forgotpasswordEmail: '/ul/login/forgetpassword/email',
    forgotpasswordPhone: '/ul/login/forgetpassword/phone',
    signup: '/ul/login/signup',
    signupEmail: '/ul/login/signup\\?type=email',
    signupPhone: '/ul/login/signup\\?type=phone',
    changePassword: '/ul/login/changepassword',
    weChatAuth: '/ul/login/oauth/wechat',
    lineAuth: '/ul/login/oauth/line',
    deleteAccount: '/ul/login/account/delete',
    mfa: '/ul/mfa/citi',
    verifyOtp: '/ul/mfa/otp',
    phoneAssociation: '/ul/mfa/phoneassociation',
    socialAssociation: '/ul/login/associate',
    signoutAll: '/ul/login/account/signoutall',
    walletResetPin: '/ul/mfa/pin/reset',
    walletAuth: '/ul/mfa/pin/auth',
    walletSca: '/ul/mfa/sca/auth',
    registerPasskey: '/ul/mfa/passkey/register',
};

/**
 * hook to get path with culture code
 *
 * @param path
 * @requires AppContext
 */
export const usePath = (path: ULPath) => {
    const { cultureCode } = useAppContext();
    const url = pathRecord[path];

    return `/${cultureCode}/${url.startsWith('/') ? url.slice(1) : url}`;
};

export const useInitialPath = () => {
    const { initialPath } = useAppContext();
    // Ensure initial path is valid, else use default signin
    const path = initialPath && initialPath in pathRecord ? initialPath : 'signin';
    return usePath(path);
};

export const extractPathAndSearch = (pathAndSearch: string) => {
    const { searchParams, pathname } = new URL(pathAndSearch, window.location.origin);

    // Carry over current query params
    const { searchParams: currentParams } = new URL(window.location.href);
    const persistedParams = [...(__PROD__ ? [] : ['ul_api', 'UL_BRANCH']), 'appId'];
    currentParams.forEach((value, key) => persistedParams.includes(key) && searchParams.set(key, value));

    return {
        searchParams,
        pathname,
    };
};
